import React, { memo } from 'react'

import PoweredBy from '../../../../components/shared/footer/PoweredBy'

const PoweredByWrapper = () => <PoweredBy />

export default memo(PoweredByWrapper)
